import React from "react";
import { Check, ReceiptText, UserRound } from "lucide-react";

export function FaceVideoGuideAnimation() {
  return (
    <div
      className="kyc-guide-animation face-guide-animation"
      aria-hidden="true"
    >
      <div className="face-guide-stage">
        <span className="face-guide-recording-dot" />
        <span className="face-guide-corner face-guide-corner-tl" />
        <span className="face-guide-corner face-guide-corner-tr" />
        <span className="face-guide-corner face-guide-corner-br" />
        <span className="face-guide-corner face-guide-corner-bl" />
        <div className="face-guide-oval">
          <span className="face-guide-head">
            <UserRound className="face-guide-person-icon" strokeWidth={1.35} />
          </span>
          <span className="face-guide-scan-line" />
        </div>
      </div>
    </div>
  );
}

export function AddressProofGuideAnimation() {
  return (
    <div
      className="kyc-guide-animation address-guide-animation"
      aria-hidden="true"
    >
      <div className="address-guide-stage">
        <span className="address-guide-sheet address-guide-sheet-back" />
        <div className="address-guide-sheet address-guide-sheet-front">
          <span className="address-guide-icon">
            <ReceiptText className="size-7" strokeWidth={1.7} />
          </span>
          <span className="address-guide-lines">
            <span className="address-guide-line address-guide-line-long" />
            <span className="address-guide-line address-guide-line-medium" />
            <span className="address-guide-line address-guide-line-short" />
          </span>
          <span className="address-guide-scan-line" />
        </div>
        <span className="address-guide-success">
          <Check className="size-5" strokeWidth={2.8} />
        </span>
      </div>
    </div>
  );
}
